var PRODUCT = [];
PRODUCT.SPECIFICATIONS = [];
PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = null;


/*
|--------------------------------------------------------------------------
| Product Form Repeater
|--------------------------------------------------------------------------
*/

$(function () {
    // /* $ Selectors ============================== */
    // const DATA_TOTAL_ROWS = 'total-rows';
    // const ID_VARIATIONS = '#variation';
    // const ID_VARIATIONS_TABLE = '#variations-table';
    // const ID_VARIATIONS_TABLE_BODY = '#variations-table tbody';

    populateOldValues();
    fetchInvoiceProductsRecords();
    populateInvoiceProductsInputFields();

    $('.products__add').on('click', function (e) {

        e.preventDefault();

        // toastr.options = {
        //     "closeButton": true,
        //     "newestOnTop": true,
        //     "positionClass": "toast-top-right"
        // };

        var product = {};
        var totalRows = $(this).data('total-rows');
        product['specification'] = $('#specification').val();
        product['detail'] = $('#detail').val();
        product['totalRows'] = PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW === null ? Number(totalRows) + 1 : PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW.totalRows;

        if (product['specification'] === '') {
            toastr.error('Please Enter Specification Title');
            return 0;
        }
        if (product['detail'] === '') {
            toastr.error('Please Enter Specification Detail');
            return 0;
        }

        if (PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW === null) {
            $(this).data('total-rows', product['totalRows']);
        } else {
        }

        addVariationsToVariationsTable(product);
        clearVariationsFields();

        if (PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW !== null) {
            PRODUCT.SPECIFICATIONS = $.grep(PRODUCT.SPECIFICATIONS, function (row) {
                return row.totalRows !== PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW.totalRows;
            });
            PRODUCT.SPECIFICATIONS.push(product);
            $(`tbody#table_body tr[data-id="${PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW.totalRows}"]`).css('background-color', '');
        } else {
            PRODUCT.SPECIFICATIONS.push(product);
        }

        populateInvoiceProductsInputFields();

        $('#total').val(product['total']);

        PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = null;

    });

    function clearVariationsFields() {
        $('#specification').val('');
        $('#detail').val('');
    }

    $(document).on('click', '.product__edit', function (e) {
        e.preventDefault();

        if (PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW !== null) {
            toastr.error(`${PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW.productDescription} is already in Edit`);
            return 0;
        }

        var productId = $(this).data('id');
        console.log(productId);
        console.log(PRODUCT.SPECIFICATIONS);
        var edit_row = PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = PRODUCT.SPECIFICATIONS.find(row => row.totalRows === productId);

        $(`tbody#table_body tr[data-id="${productId}"]`).attr('style', 'background-color: rgba(247, 152, 30, 0.42) !important');

        console.log('edit_row: ', edit_row);
        $('#specification').val(edit_row.specification);
        $('#detail').val(edit_row.detail);
    });

    $(document).on('click', '.product__delete', function (e) {
        e.preventDefault();

        var productId = $(this).data('id');

        $(`tbody#table_body tr[data-id="${productId}"]`).remove();

        if ($(`tbody#table_body tr`).length < 1) {
            $('.products__add').data('total-rows', 0);
        }

        PRODUCT.SPECIFICATIONS = $.grep(PRODUCT.SPECIFICATIONS, function (row) {
            return row.totalRows !== productId;
        });
        populateInvoiceProductsInputFields();

        PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = 'delete';
        PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = null;
    });

});

window.populateOldValues = () => {
    var items = $('#productsData').val();
    if (items == null || items === '') return 0;
    console.log(JSON.parse(items));
    items = JSON.parse(items);
    $.each(items, function (index, item) {
        var data = {};
        data['totalRows'] = index + 1;
        data['specification'] = item['specification'];
        data['detail'] = item['detail'];

        addVariationsToVariationsTable(data);
    });
};


window.fetchInvoiceProductsRecords = () => {
    $.each($('tbody#table_body tr'), function (index, tr) {
        console.log(tr);
        var data = {};
        data['totalRows'] = Number(tr.children[0].innerHTML);
        data['specification'] = tr.children[1].innerHTML;
        data['detail'] = tr.children[2].innerHTML;
        data['edited'] = false;
        data['product'] = 's';

        PRODUCT.SPECIFICATIONS.push(data);
    });
    console.log(PRODUCT.SPECIFICATIONS);
};

window.clearProductVariationVariables = () => {
    PRODUCT.SPECIFICATIONS = [];
    PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW = null;
};

window.addVariationsToVariationsTable = (product) => {
    var row = $(`
           <tr data-id="${product['totalRows']}">
                <th class="col col-sm-1 col-md-1 col-lg-1 col-xl-1">${product['totalRows']}</th>
                <td>${product['specification']}</td>
                <td>${product['detail']}</td>
                <td class="col col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <button type="button" data-id="${product['totalRows']}" class="btn btn-success float-right btn-floating ml-2 product__edit"><i class="icofont-pencil"></i></button>
                    <button type="button" data-id="${product['totalRows']}" class="btn btn-danger float-right btn-floating product__delete " ><i class="icofont-trash"></i></button>
                </td>
            </tr>
        `);

    if (PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW !== null) {
        $(`tbody#table_body tr[data-id="${PRODUCT.SPECIFICATIONS_CURRENTLY_EDIT_ROW.totalRows}"]`).replaceWith(row);
        return 0;
    }

    console.log(row);

    $('tbody#table_body').append(row);
};

window.populateInvoiceProductsInputFields = () => {
    var products = [];

    $.map(PRODUCT.SPECIFICATIONS, function (row, i) {
        var specification = $.trim(row.specification);
        var detail = $.trim(row.detail);

        product = {};
        product['specification'] = specification;
        product['detail'] = detail;

        products.push(product);
    });

    console.log(products);
    console.log(JSON.stringify(products));

    $('#productsData').val(JSON.stringify(products));
};

